import { Box, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { useState } from "react";
import AppSnackbar from "../components/common/AppSnackbar";
import { NewSaleEntry } from "../components/sales/newSaleEntry";
import RecentSales from "../components/sales/RecentSales";
import styles from "./salesScreenStyles";

const NewSale = () => {
  const [saleType, setSaleType] = useState("new");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];

  return (
    <>
      <Box sx={styles.mainBox}>
        <Box sx={styles.radioRow}>
          <RadioGroup
            row
            value={saleType}
            onChange={(e) => setSaleType(e.target.value)}
            sx={styles.radioGroup}
          >
            <FormControlLabel
              value="new"
              label="New Sales"
              labelPlacement="end"
              control={<Radio sx={styles.radio} />}
            />
            <FormControlLabel
              value="recent"
              label="Recent Sales"
              labelPlacement="end"
              control={<Radio sx={styles.radio} />}
            />
          </RadioGroup>
        </Box>
        {saleType === "new" ? (
          <NewSaleEntry />
        ) : (
          <RecentSales setOpenSnackbar={setOpenSnackbar} />
        )}
      </Box>
      <AppSnackbar
        message="Successfully Updated!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

export default NewSale;
